export enum GeneralMastersPermissions {
  VIEW_GENERAL_MASTERS = "view_general_masters",
  CREATE_GENERAL_MASTERS = "create_general_masters",
  UPDATE_GENERAL_MASTERS = "update_general_masters",
  DELETE_GENERAL_MASTERS = "delete_general_masters",
  ARCHIVE_GENERAL_MASTERS = "archive_general_masters",
}

export const GeneralMastersPermissionsText: Record<
  GeneralMastersPermissions,
  string
> = {
  [GeneralMastersPermissions.VIEW_GENERAL_MASTERS]: "View General Masters",
  [GeneralMastersPermissions.CREATE_GENERAL_MASTERS]: "Create General Masters",
  [GeneralMastersPermissions.UPDATE_GENERAL_MASTERS]: "Update General Masters",
  [GeneralMastersPermissions.DELETE_GENERAL_MASTERS]: "Delete General Masters",
  [GeneralMastersPermissions.ARCHIVE_GENERAL_MASTERS]:
    "Archive General Masters",
};
